import React from 'react';
import PropTypes from 'prop-types';
import { FilterPanel } from '@gsa/afp-component-library';
import { useStandards } from './standards-provider';

const { FilterPanelField, FilterPanelFilterShape } = FilterPanel;

const FedStandardCodeFilterItem = ({ filter }) => {
  const { multipleOptions } = useStandards();

  return (
    <div className="margin-top-3">
      <label htmlFor={filter.key} className="usa-label">
        {filter.title}
      </label>
      <FilterPanelField
        key={[filter.key]}
        filter={{
          ...filter,
          type: 'select',
          options: multipleOptions?.fedStandardCode || [],
        }}
      />
    </div>
  );
};

FedStandardCodeFilterItem.propTypes = {
  filter: PropTypes.shape(FilterPanelFilterShape).isRequired,
};

export default FedStandardCodeFilterItem;
